import { Observable } from 'rxjs';

export const SecurityAuthenticationViewContractId =
  'SecurityAuthenticationViewContractId';

export interface AuthenticationViewContract {
  accessToken$: Observable<string>;
  name$: Observable<string>;
  email$: Observable<string>;
  picture$: Observable<string>;
  permissions$: Observable<string[]>;
  isAuthenticated$: Observable<boolean>;
  qrCode$: Observable<string>;
  logoUrl$: Observable<string>;
  companyName$: Observable<string>;
  qrCodeAppTitle$: Observable<string>;
  license$: Observable<string>;
  version$: Observable<string>;
  borderColor$: Observable<string>;
  borderWidth$: Observable<string>;
  versionColor$: Observable<string>;
  loginRedirect$: Observable<string>;
  display$: Observable<string>;

  login(code?: string): void;
  logout(): void;
  generateQrCode(): void;
  gotoTurnOn(): void;
  gotoGenerateQrCode(): void;
  turnOn2fa(): void;
  validate2fa(): void;
  setColors(): void;
}
